import { ReactNode, useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../utils/hooks/redux";
import { selectAuthRequestStatus, selectAuthStatus } from "../redux/features/auth/selectors";
import { getProfileInfoThunkAsync } from "../redux/features/auth/authAsyncThunk";
import { RequestResults } from "../redux/common/RequestStatus";
import { Navigate } from "react-router-dom";
import SystemPayRoutes from "../utils/constants/Routes";
import { Spin } from "antd";

const AuthRoute: React.FC<{ element: ReactNode }> = ({ element }) => {
  const isAuthenticated = useAppSelector(selectAuthStatus);
  const status = useAppSelector(selectAuthRequestStatus);
  const dispatch = useAppDispatch();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (status === RequestResults.idle && token !== null) {
      dispatch(getProfileInfoThunkAsync());
    }
  }, [status, token]);

  return status === RequestResults.pending && token ? (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <Spin size="large" />
    </div>
  ) : isAuthenticated && token ? (
    // Default landing = In Process. The client's day-to-day work happens here
    // (claims past the highlight window, ready to action), so dropping straight
    // into this single-column view both matches the workflow AND speeds up first
    // paint — the board fetcher only loads ONE column (InProcess) on this route
    // instead of the multi-column batch the main /reports kanban triggers.
    <Navigate to={`${SystemPayRoutes.reports}/in-process`} />
  ) : (
    <> {element}</>
  );
};

export default AuthRoute;
